import React from 'react';
import Button from '../components/Button';

export default function ConfirmDialog({
  title = 'Confirm',
  bodytext = 'Are you sure?',
  cancleBtnText = 'No',
  SuccessBtnText = 'Yes',
  closeDialog,
  asyncClose = false,
  successDialog,
  sucPrams,
  comCurtain = false,
}) {
  return (
    <div className="modalBackground">
      <div className="logout-contnr" style={comCurtain ? { width: '50%' } : {}}>
        <span className="logout-hdng">{title}</span>
        <span className="logout-text tab-bg">{bodytext}</span>
        <span className="flex-sec logout-action justify-end gap10">
          <Button
            onClick={closeDialog}
            className=""
            style={{ padding: '5px 30px' }}
          >
            {cancleBtnText}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              successDialog(sucPrams);
              if (!asyncClose) {
                closeDialog();
              }
            }}
            style={{ padding: '5px 30px' }}
          >
            {SuccessBtnText}
          </Button>
          {/* <button
            onClick={() => {
              successDialog(sucPrams);
              if (!asyncClose) {
                closeDialog();
              }
            }}
            className="actn-yes width-unset"
            style={{ padding: '6px 35px' }}
          >
            {SuccessBtnText}
          </button> */}
          {/* <button
            onClick={closeDialog}
            className="actn-No width-unset"
            style={{ padding: '6px 35px' }}
          >
            {cancleBtnText}
          </button> */}
        </span>
      </div>
    </div>
  );
}
